<template>
  <button
    v-bind="$attrs"
    class="tw-inline-flex tw-w-full tw-select-none tw-items-center tw-justify-center tw-rounded-md tw-border tw-py-2 tw-transition-colors disabled:tw-cursor-not-allowed"
    :class="[
      isSelected
        ? 'tw-border-primary-500 tw-bg-primary-500 tw-text-white hover:tw-border-primary-400 hover:tw-bg-primary-400'
        : 'tw-border-primary-200 tw-text-primary-500 hover:tw-border-primary-50 hover:tw-bg-primary-50',
    ]"
    :test_id="`slot-${startsAt}`"
  >
    <time :datetime="ISOString">
      {{ formatDate(startsAt, 'hh:mm a') }}
    </time>
    <CheckIcon v-show="isSelected" class="tw-ml-1 tw-h-2.5 tw-w-2.5" />
  </button>
</template>

<script setup>
import CheckIcon from '@/assets/images/icons/check.svg'
import { DateTime } from 'luxon'
import { computed } from 'vue'
import { useDateManager } from '@/shared/composables/useDateManager.js'

const props = defineProps({
  isSelected: {
    type: Boolean,
    required: true,
  },
  startsAt: {
    type: Number,
    required: true,
  },
})

const { formatDate } = useDateManager()

const ISOString = computed(() => {
  return DateTime.fromSeconds(props.startsAt).toISO()
})
</script>
